import React from 'react';
import PropTypes from 'prop-types';
import { formatPriceStringV2 } from 'client/site-modules/shared/utils/price-utils';
import { ExplanatoryText } from 'site-modules/lease-deals/components/key-insights-list/explanatory-text';

export function EffectivePaymentInsight({
  effectivePayment,
  effectivePaymentMedian,
  bodyType = undefined,
  showEffectivePaymentText = false,
}) {
  const isEffectivePaymentLower = effectivePaymentMedian > effectivePayment;
  const savingsPrice = isEffectivePaymentLower
    ? effectivePaymentMedian - effectivePayment
    : effectivePayment - effectivePaymentMedian;
  const firstPart = `${formatPriceStringV2(savingsPrice)}/mo ${isEffectivePaymentLower ? 'lower' : 'higher'}`;
  const secondPart = `${showEffectivePaymentText ? 'effective payment' : ''} than `;
  const summary = (
    <span>
      <strong>{firstPart}</strong> {secondPart}
    </span>
  );

  return (
    <ExplanatoryText
      summary={summary}
      toggleSummary="similar cars"
      details={`Comparison is based off the median lease payment estimate for similar ${bodyType ? `${bodyType}` : 'vehicle'}s with a 36 month term and 12,000 annual mile lease.`}
    />
  );
}

EffectivePaymentInsight.propTypes = {
  effectivePayment: PropTypes.number.isRequired,
  effectivePaymentMedian: PropTypes.number.isRequired,
  bodyType: PropTypes.string,
  showEffectivePaymentText: PropTypes.bool,
};
